import axios from '@axios'
import useJwt from '@core/auth/jwt/useJwt'

export const { jwt } = useJwt(axios, {})

export const isUserLoggedIn = () => {
    return Boolean(jwt.getToken())
}

export const silentLogin = () => {
    return jwt.refreshToken()
}

export const forceLogout = () => {
    return jwt.logout()
}

